var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90918 15L8.90918 17L13.4092 12.5M8.90918 8V5.2C8.90918 4.0799 8.90918 3.51984 9.12717 3.09202C9.31891 2.71569 9.62487 2.40973 10.0012 2.21799C10.429 2 10.9891 2 12.1092 2H19.7092C20.8293 2 21.3893 2 21.8172 2.21799C22.1935 2.40973 22.4994 2.71569 22.6912 3.09202C22.9092 3.51984 22.9092 4.0799 22.9092 5.2V12.8C22.9092 13.9201 22.9092 14.4802 22.6912 14.908C22.4994 15.2843 22.1935 15.5903 21.8172 15.782C21.3893 16 20.8293 16 19.7092 16H16.9092M6.10918 22H13.7092C14.8293 22 15.3893 22 15.8172 21.782C16.1935 21.5903 16.4994 21.2843 16.6912 20.908C16.9092 20.4802 16.9092 19.9201 16.9092 18.8V11.2C16.9092 10.0799 16.9092 9.51984 16.6912 9.09202C16.4994 8.71569 16.1935 8.40973 15.8172 8.21799C15.3893 8 14.8293 8 13.7092 8H6.10918C4.98907 8 4.42902 8 4.0012 8.21799C3.62487 8.40973 3.31891 8.71569 3.12717 9.09202C2.90918 9.51984 2.90918 10.0799 2.90918 11.2V18.8C2.90918 19.9201 2.90918 20.4802 3.12717 20.908C3.31891 21.2843 3.62487 21.5903 4.0012 21.782C4.42902 22 4.98907 22 6.10918 22Z",
    stroke: "#5C6469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.ebd99615c6142d32c8e78849f08b2c57.svg";
export { ForwardRef as ReactComponent };